import * as types from '../mutation-types'
import userService from '../../services/users'

const state = {
    loading: false,
    errors: null,
    admins: []
}

const actions = {
    getAll({ commit }) {
        commit(types.ADMIN_LOADING, true)
        userService.getAll({utype:"admins"}).then(
            response => {

                commit(types.LOAD_ADMINS, response.data)
                commit(types.ADMIN_LOADING, false)
            },
            error => {
                commit(types.ADMIN_FAILURE, error)
                commit(types.ADMIN_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
      //console.log("puuuu",data)

        commit(types.ADMIN_LOADING, true)
        commit(types.ADMIN_FAILURE, null)
        userService.add(data).then(
            response => {
              //console.log(response)
                data.id = response.data.id
                commit(types.ADD_ADMIN, data)
                commit(types.ADMIN_LOADING, false)
            },
            error => {
                commit(types.ADMIN_FAILURE, error)
                commit(types.ADMIN_LOADING, false)

            }
        )
    },
    update({ commit }, data) {
        commit(types.ADMIN_LOADING, true)
        commit(types.ADMIN_FAILURE, null)
        userService.update(data.user)
            .then(
                response => {
                    commit(types.UPDATE_ADMIN, data)
                    commit(types.ADMIN_LOADING, false)
                },
                error => {
                    commit(types.ADMIN_FAILURE, error)
                    commit(types.ADMIN_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.ADMIN_LOADING, true)
        commit(types.ADMIN_FAILURE, null)
         //alert(data)
        userService.delete(data.admin.id)
            .then(
                response => {

                    commit(types.DELETE_ADMIN, data)
                    commit(types.ADMIN_LOADING, false)
                },
                error => {
                    commit(types.ADMIN_FAILURE, error)
                    commit(types.ADMIN_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_ADMIN](state, payload) {
      console.log("a to be added....",payload)
        state.admins.unshift(payload);
    },
    [types.LOAD_ADMINS](state, payload) {
        state.admins = payload
    },
    [types.UPDATE_ADMIN](state, payload) {
        Object.assign(state.admins[payload.index], payload.user);
    },
    [types.DELETE_ADMIN](state, payload) {
        state.admins.splice(payload.index, 1)
    },
    [types.ADMIN_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.ADMIN_LOADING](state, payload) {
        state.loading = payload
    },
}


const getters = {
    ADMINS: state => {
        return state.admins
    },

    ADMIN_ERROR: state => {
        return state.errors
    },

    ADMIN_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/admins.js